'use client'

import type { Editor } from '@tiptap/react'
import { headingButtonsBasic, headingButtonsExtended } from './editor-toolbar.config'
import { EditorToolbarButtonGroup } from './editor-toolbar-button-group.atom'
import { EditorToolbarDivider } from './editor-toolbar-divider.atom'

export interface EditorToolbarHeadingsProps {
  editor: Editor
  isDisabled?: boolean
  isBasicOnly?: boolean
}

/**
 * Heading buttons section (H1-H4) for the editor toolbar
 */
export const EditorToolbarHeadings = ({
  editor,
  isDisabled = false,
  isBasicOnly = false,
}: EditorToolbarHeadingsProps) => (
  <>
    <EditorToolbarDivider />
    <EditorToolbarButtonGroup
      editor={editor}
      buttonList={headingButtonsBasic}
      isDisabled={isDisabled}
    />
    {!isBasicOnly && (
      <EditorToolbarButtonGroup
        editor={editor}
        buttonList={headingButtonsExtended}
        isDisabled={isDisabled}
      />
    )}
  </>
)

EditorToolbarHeadings.displayName = 'EditorToolbarHeadings'
